import { JeomsinDomain } from "@Network/network_constants"

export const TrackingScreenKey = {
    //기타
    view_aside_page: {id: 'view_aside_page', name: '좌측메뉴'}, // 실제로 호출되지는 않고 기록용으로 할당된 키 값
    view_onboarding_01: {id: 'view_onboarding_01', name: '점신시작하기_01'},
    view_onboarding_02: {id: 'view_onboarding_02', name: '점신시작하기_02'},
    view_onboarding_03: {id: 'view_onboarding_03', name: '점신시작하기_03'},
    view_onboarding_04: {id: 'view_onboarding_04', name: '점신시작하기_04'},
    // view_onboarding_agree: {id: 'view_onboarding_agree', name: '점신시작하기_이용약관동의'},
    // view_onboarding_sns: {id: 'view_onboarding_sns', name: '점신시작하기_SNS연동하기'},
    view_onboarding_verification: {id: 'view_onboarding_verification', name: '회원휴대폰인증'},
    view_saju_add: {id: 'view_saju_add', name: "사주정보입력"},
    view_saju_modify: {id: 'view_saju_modify', name: "사주정보수정"},
    view_representative_saju_add: {id: 'view_representative_saju_add', name: "대표사주정보입력"},
    view_terms_of_service: {id: 'view_terms_of_service', name: "서비스이용약관"},
    view_privacy_policy: {id: 'view_privacy_policy', name: "개인정보처리방침"},
    view_youth_protection_policy: {id: 'view_youth_protection_policy', name: "청소년보호정책"},

    view_fortune_report: {id: 'view_fortune_report', name: '점신탭'}, // 앱 이용가이드로 구현 중
    view_jeomsin_mall: {id: 'view_jeomsin_mall', name: '점신몰탭'}, // 앱 이용가이드로 구현 중

    view_phonenumber_add: {id: 'view_phonenumber_add', name: '휴대폰번호등록'},
    view_phonenumber_change: {id: 'view_phonenumber_change', name: '휴대폰번호변경'},

    //운세 탭
    view_fortune: {id: 'view_fortune', name: '운세탭'},
    view_gunghap_blood_type: {id: 'view_gunghap_blood_type', name: '혈액형궁합'},
    view_love_blood_type: {id: 'view_love_blood_type', name: '혈액형연애운세'},
    view_gunghap_zodiac: {id: 'view_gunghap_zodiac', name: '별자리궁합'},
    view_diet_zodiac: {id: 'view_diet_zodiac', name: '별자리다이어트'},
    view_house_moving: {id: 'view_house_moving', name: '이사택일'},
    view_luck_number: {id: 'view_luck_number', name: '행운의번호'},
    view_salpuri: {id: 'view_salpuri', name: '살풀이'},
    view_worries_dream_interpretation_type: {id: 'view_worries_dream_interpretation_type', name: '꿈해몽'},
    view_worries_dream_interpretation_list: {id: 'view_worries_dream_interpretation_list', name: '꿈해몽목록'},
    view_worries_dream_prenatal_type: {id: 'view_worries_dream_prenatal_type', name: '태몽'},
    view_worries_dream_prenatal_list: {id: 'view_worries_dream_prenatal_list', name: '태몽목록'},
    view_worries_dream_search: {id: 'view_worries_dream_search', name: '꿈해몽검색'},
    view_love_celebrity: {id: 'view_love_celebrity', name: '연예인궁합'},
    view_love_celebrity_add_request: {id: 'view_love_celebrity_add_request', name: '연예인궁합추가요청'},
    view_love_celebrity_search: {id: 'view_love_celebrity_search', name: '연예인궁합검색'},
    view_sajumyungsik_guide: {id: 'view_sajumyungsik_guide', name: '사주명식가이드'}, 
    view_saju_explanation: {id: 'view_saju_explanation', name: '사주설명'},
    view_ohang_explanation: {id: 'view_ohang_explanation', name: '음양오행이란?'},
    view_saju_myunsik: {id: 'view_saju_myunsik', name: "사주명식"},
    view_saju_myunsik_couple: {id: 'view_saju_myunsik_couple', name: "사주명식커플"},
    view_saju_loading: {id: 'view_saju_loading', name: "사주명식분석"}, 
    view_unse_result_newyear: {id: 'view_unse_result_newyear', name: "신년운세"},
    view_unse_result_tojeongbigyeol: {id: 'view_unse_result_tojeongbigyeol', name: "토정비결"},
    view_unse_result_jeongtongsaju: {id: 'view_unse_result_jeongtongsaju', name: "정통사주"},
    view_unse_result_today: {id: 'view_unse_result_today', name: "오늘의운세"},
    view_unse_result_tomorrow: {id: 'view_unse_result_tomorrow', name: "내일의운세"},
    view_unse_result_selected_date: {id: 'view_unse_result_selected_date', name: "지정일운세"},
    view_unse_result_lucky_number: {id: 'view_unse_result_lucky_number', name: "행운의번호"},
    view_unse_result_chunsaeng: {id: 'view_unse_result_chunsaeng', name: "천생복덕운"},
    view_unse_result_house_moving: {id: 'view_unse_result_house_moving', name: "이사택일상세"},
    view_unse_result_salpuri: {id: 'view_unse_result_salpuri', name: "살풀이"},
    view_unse_result_workunse: {id: 'view_unse_result_workunse', name: "취업운세"},
    view_unse_result_abliity_evaluation: {id: 'view_unse_result_abliity_evaluation', name: "능력평가"},
    view_unse_result_psychological_analysis: {id: 'view_unse_result_psychological_analysis', name: "심리분석"},
    view_unse_result_chinese_zodiac: {id: 'view_unse_result_chinese_zodiac', name: "띠운세"},
    view_unse_result_zodiac: {id: 'view_unse_result_zodiac', name: "별자리운세"},
    view_unse_result_gyejeol: {id: 'view_unse_result_gyejeol', name: "태어난계절운"},
    view_unse_result_birth_date: {id: 'view_unse_result_birth_date', name: "생년월일운세"},
    view_unse_result_jeonsaeng: {id: 'view_unse_result_jeonsaeng', name: "전생운"},
    view_unse_result_birth_stone: {id: 'view_unse_result_birth_stone', name: "탄생석"},
    view_unse_result_gunghap_match: {id: 'view_unse_result_gunghap_match', name: "짝궁합"},
    view_unse_result_gunghap_jeongtong: {id: 'view_unse_result_gunghap_jeongtong', name: "정통궁합"},
    view_unse_result_gunghap_blood_type: {id: 'view_unse_result_gunghap_blood_type', name: "혈액형궁합"},
    view_unse_result_love_blood_type: {id: 'view_unse_result_love_blood_type', name: "혈액형연애운세"},
    view_unse_result_gunghap_zodiac: {id: 'view_unse_result_gunghap_zodiac', name: "별자리궁합"},
    view_unse_result_diet_zodiac: {id: 'view_unse_result_diet_zodiac', name: "별자리다이어트"},
    view_unse_result_gunghap_celeb: {id: 'view_unse_result_gunghap_celeb', name: "연예인궁합"},
    view_unse_result_gunghap_ineyun: {id: 'view_unse_result_gunghap_ineyun', name: "나의인연운세"},

    w_view_event: {id: 'w_view_event', name: ""}, //사주명식

    //상담 탭
    view_counselling: {id: 'view_counselling', name: '상담탭'},
    view_counselling_top_banner_list: {id: 'view_counselling_top_banner_list', name: '상담배너리스트'},
    view_counselling_3mins_free_list: {id: 'view_counselling_3mins_free_list', name: '3분무료상담리스트'},
    view_counselling_3mins_free_guide: {id: 'view_counselling_3mins_free_guide', name: '3분무료상담안내'},
    view_counselling_free: {id: 'view_counselling_free', name: '무료고민상담'},
    view_counselling_free_write: {id: 'view_counselling_free_write', name: '무료고민상담작성'},
    view_counselling_my_worry_list: {id: 'view_counselling_my_worry_list', name: '내가남긴고민'},
    view_counselling_guide: {id: 'view_counselling_guide', name: '상담이용가이드'},
    view_counselling_guide_coin_benefit: {id: 'view_counselling_guide_coin_benefit', name: '코인상담혜택가이드'},
    view_counselling_list: {id: 'view_counselling_list', name: '전문상담사리스트'},
    view_counselling_simli_guide: {id: 'view_counselling_simli_guide', name: '심리상담안내'},
    view_profile: {id: 'view_profile', name: "상담사프로필"}, //상담사 상세
    // view_counselling_top_banner_detail_list: {id: 'view_counselling_top_banner_detail_list', name: '상담_배너_상세_리스트'},
    view_counselling_free_write_saju_add: {id: 'view_counselling_free_write_saju_add', name:'상담_무료고민상담_글쓰기_사주정보 추가'},
    view_counselor_report: {id: 'view_counselor_report', name: '상담후기신고하기'},
    view_apply_counseling: {id: 'view_apply_counseling', name: "상담사연결하기"},
    view_counselling_field_list: {id: 'view_counselling_field_list', name: '분야별상담사리스트'},

    //마이페이지
    view_mypage: {id: 'view_mypage', name: '마이페이지'},
    view_my_account: {id: 'view_my_account', name: '계정관리'},
    view_my_counselling_history: {id: 'view_my_counselling_history', name: '상담내역'},
    view_my_counselling_history_detail: {id: 'view_my_counselling_history_detail', name: '상담상세내역'},
    view_my_coupon: {id: 'view_my_coupon', name: '쿠폰함_보유쿠폰'},
    view_my_coupon_download: {id: 'view_my_coupon_download', name: '쿠폰함_쿠폰받기'},
    view_my_favorite_counselor: {id: 'view_my_favorite_counselor', name: '찜한상담사'},
    view_my_fortunetelling_info_today: {id: 'view_my_fortunetelling_info_today', name: '사주정보관리_오늘의운세'},
    view_my_fortunetelling_info_tomrrow: {id: 'view_my_fortunetelling_info_tomrrow', name: '사주정보관리_내일의운세'},
    view_my_notice: {id: 'view_my_notice', name: '공지사항'},
    view_my_purchase_history: {id: 'view_my_purchase_history', name: '구매내역'},
    view_my_review_not_write: {id: 'view_my_review', name: '후기관리_후기쓰기'},
    view_my_review_writing: {id: 'view_my_review_writing', name: '후기 작성'},
    view_my_review_written: {id: 'view_my_review_written', name: '후기관리_내가쓴후기'},
    view_my_review_modifing: {id: 'view_my_review_modifing', name: '후기수정'},
    view_my_wallet: {id: 'view_my_wallet', name: '내지갑'},
    view_my_wallet_add_card_password_01: {id: 'view_my_wallet_add_card_password_01', name: '간편카드패스워드등록_01'},
    view_my_wallet_add_card_password_02: {id: 'view_my_wallet_add_card_password_02', name: '간편카드패스워드등록_02'},
    view_my_wallet_add_card: {id: 'view_my_wallet_add_card', name: '간편카드등록'},
    view_my_wallet_check_password: {id: 'view_my_wallet_check_password', name: '간편카드패스워드체크'},
    view_my_wallet_check_wrong_password: {id: 'view_my_wallet_check_wrong_password', name: '간편카드패스워드실패'},
    view_my_wallet_charging: {id: 'view_my_wallet_charging', name: '점신충전소'},
    view_my_wallet_history: {id: 'view_my_wallet_history', name: '코인내역'},
    view_search: {id: 'view_search', name: '메뉴검색'},
    view_search_counselor: {id: 'view_search_counselor', name: '상담사검색'},
    view_my_cs_faq: {id: 'view_my_cs_faq', name: '고객센터_FAQ'},
    view_my_cs_qna_list: {id: 'view_my_cs_qna_list', name: '고객센터_문의내역'},
    view_my_cs_qna_write: {id: 'view_my_cs_qna_write', name: '고객센터_문의하기'},
    view_setting: {id: 'view_setting', name: '설정'},
    view_mypage_normal_setting: {id: 'view_mypage_normal_setting', name: '설정_일반'},
    view_signout_01: {id: 'view_signout_01', name: '회원탈퇴'},
    view_signout_02: {id: 'view_signout_02', name: '회원탈퇴안내사항'},

    //타로 탭
    view_taro: {id: 'view_taro', name: '타로탭'},
    view_tarot_settings: {id: 'view_tarot_settings', name: '타로카드설정'},
    view_tarot_card_select: {id: 'view_tarot_select', name: '타로카드선택'},
    view_tarot_analyzing: {id: 'view_tarot_analyzing', name: '타로사주분석'},
    view_tarot_result_today: {id: 'view_tarot_result_today', name: '오늘의타로결과'},
    view_tarot_result_month: {id: 'view_tarot_result_month', name: '이달의타로결과'},
    view_tarot_result_curious: {id: 'view_tarot_result_curious', name: '궁금한타로결과'},
    view_tarot_card_explanation: {id:"view_tarot_card_explanation", name:"타로카드설명"}, //타로카드 설명 TODO Check

    view_develop: {id: 'view_develop', name: '개발중인 화면'}
}
export type TrackingScreenKey = (typeof TrackingScreenKey)[keyof typeof TrackingScreenKey]

export const TrackingContentTypeKey = {
    appbar: "앱바",
    bottomNav: "하단바",
    asidePage: "PC좌측페이지",
    jeomsin: "점신",
    unse: "운세",
    taro: "타로",
    counseling: "상담",
    jeomsinMall: "점신몰",
    mypage: "마이페이지",
    onboarding: "점신시작하기"
}
export type TrackingContentTypeKey = (typeof TrackingContentTypeKey)[keyof typeof TrackingContentTypeKey]

export const TrackingShareMethodKey = {
    url:"URL",
    image:"Image",
    kakao:"Kakao",
}
export type TrackingShareMethodKey = (typeof TrackingShareMethodKey)[keyof typeof TrackingShareMethodKey]